import { createStore, } from 'vuex';
import auth from '@/vuex-store/auth';
import order from '@/vuex-store/order';
import user from '@/vuex-store/user';
import worker from '@/vuex-store/worker';
import snackbar from '@/vuex-store/snackbar';
import hub from '@/vuex-store/hub';
import authVerification from '@/vuex-store/auth-verification';
import bank from '@/vuex-store/bank';
import alert from '@/vuex-store/alert';
import baromoney from '@/vuex-store/baromoney';
import app from '@/vuex-store/app';
import systemCode from '@/vuex-store/system-code';
import fulfillment from '@/vuex-store/fulfillment';
import deliveryHistory from '@/vuex-store/delivery-history';
import modalOrderInfo from '@/vuex-store/modal-order-info';
import modalWorkerInfo from '@/vuex-store/modal-worker-info';
import hubSelector from '@/vuex-store/hub-selector';
import operationSetting from '@/vuex-store/operation-setting';
import operationSettingHistory from '@/vuex-store/operation-setting-history';
import storeAdjustment from '@/vuex-store/store-adjustment';
import storeAdjustmentDetail from '@/vuex-store/store-adjustment-detail';
import baromoneyReport from '@/vuex-store/baromoney-report';
import workerInformationDetail from '@/vuex-store/worker-adjustment/worker-information-detail';
import deliveryFeeGroupSetting from '@/vuex-store/delivery-fee-group-setting';
import allocatedCancelPenaltyGroupSetting from '@/vuex-store/allocated-cancel-penalty-group-setting';
import cashAutoDeductGroupSetting from '@/vuex-store/cash-auto-deduct-group-setting';
import paymentDetail from '@/vuex-store/worker-adjustment/payment-detail';
import simplePaymentDetail from '@/vuex-store/worker-adjustment/simple-payment-detail';
import withholdTaxReport from '@/vuex-store/worker-adjustment/withhold-tax-report';
import detailsPerWorker from '@/vuex-store/worker-adjustment/details-per-worker';
import storeList from '@/vuex-store/store-management/store-list';
import storeBulkEdit from '@/vuex-store/store-management/store-bulk-edit';
import storeCreate from '@/vuex-store/store-management/store-create';
import workerFeePerStoreGroupSetting from '@/vuex-store/store-management/worker-fee-per-store-group-setting';
import workerFeePerStoreGroupStoreSetting from '@/vuex-store/store-management/worker-fee-per-store-group-store-setting';
import storeFeeBySection from '@/vuex-store/store-management/store-fee-by-section';
import storeGoodsPriceSurchargeInfos from '@/vuex-store/store-management/store-goods-price-surcharge-infos';
import hubList from '@/vuex-store/hub-management/hub-list';
import hubEdit from '@/vuex-store/hub-management/hub-edit';
import hubCreate from '@/vuex-store/hub-management/hub-create';
import hubMainReport from '@/vuex-store/hub-adjustment/main';
import hubDailyReport from '@/vuex-store/hub-adjustment/daily';
import workerList from '@/vuex-store/worker-management/worker-list';
import workerBulkEdit from '@/vuex-store/worker-management/worker-bulk-edit';
import workerEdit from '@/vuex-store/worker-management/worker-edit';
import workerCreate from '@/vuex-store/worker-management/worker-create';
import deliveryFeeGroupWorkerSetting from '@/vuex-store/delivery-fee-group-worker-setting';
import cashAutoDeductGroupWorkerSetting from '@/vuex-store/cash-auto-deduct-group-worker-setting';
import allocatedCancelPenaltyGroupWorkerSetting from '@/vuex-store/allocated-cancel-penalty-group-worker-setting';
import coordSelectMap from '@/vuex-store/coord-select-map';
import userList from '@/vuex-store/user-management/user-list';
import userPage from '@/vuex-store/user-management/user-page';
import shareList from '@/vuex-store/share-management/share-list';
import shareConfig from '@/vuex-store/share-management/share-config';
import storeDeliveryPossibleArea from '@/vuex-store/store-delivery-possible-area';
import supplyInfoDialog from '@/vuex-store/supply-info-dialog';
import deliveryChargeAreaControl from '@/vuex-store/delivery-charge-area-control';
import taxInvoiceDialog from '@/vuex-store/hub-adjustment/tax-invoice-dialog';
import workerBaromoneyHistory from '@/vuex-store/worker-baromoney-history';
import workerBaromoneyHistoryDetailDialog from '@/vuex-store/worker-baromoney-history-detail-dialog';
import workerProfit from '@/vuex-store/worker-profit';
import workerProfitDetailDialog from '@/vuex-store/worker-profit-detail-dialog';
import workerMonthlyAttendance from '@/vuex-store/worker-monthly-attendance';
import userPermissionSettingDialog from '@/vuex-store/user-permission-setting-dialog';
import storeDetail from '@/vuex-store/store-management/store-detail';
import storeEdit from '@/vuex-store/store-management/store-edit';
import workerDetail from '@/vuex-store/worker-management/worker-detail';
import hubDetail from '@/vuex-store/hub-management/hub-detail';
import listControl from '@/vuex-store/list-control';
import mapControl from '@/vuex-store/map-control';
import allocationAlert from '@/vuex-store/allocation-alert';
import deliveryChargeDialog from '@/vuex-store/delivery-charge-dialog';
import allocationController from '@/vuex-store/allocation-controller';
import { setGlobalStore } from '@/lib/global-store';
const store = {
    modules: {
        auth,
        order,
        user,
        worker,
        snackbar,
        hub,
        authVerification,
        bank,
        alert,
        baromoney,
        app,
        mapControl,
        listControl,
        coordSelectMap,
        supplyInfoDialog,
        systemCode,
        fulfillment,
        deliveryHistory,
        modalOrderInfo,
        modalWorkerInfo,
        hubSelector,
        operationSetting,
        operationSettingHistory,
        storeAdjustment,
        storeAdjustmentDetail,
        storeManagement: {
            namespaced: true,
            modules: {
                storeList,
                workerFeePerStoreGroupSetting,
                workerFeePerStoreGroupStoreSetting,
                storeDetail,
                storeEdit,
                storeCreate,
                storeBulkEdit,
                storeFeeBySection,
                storeGoodsPriceSurchargeInfos,
            },
        },
        storeDeliveryPossibleArea,
        hubManagement: {
            namespaced: true,
            modules: {
                hubList,
                hubDetail,
                hubEdit,
                hubCreate,
            },
        },
        hubAdjustment: {
            namespaced: true,
            modules: {
                hubMainReport,
                hubDailyReport,
                taxInvoiceDialog,
            },
        },
        workerAdjustment: {
            namespaced: true,
            modules: {
                paymentDetail,
                simplePaymentDetail,
                withholdTaxReport,
                detailsPerWorker,
                workerInformationDetail,
            },
        },
        workerManagement: {
            namespaced: true,
            modules: {
                workerList,
                workerBulkEdit,
                deliveryFeeGroupSetting,
                cashAutoDeductGroupSetting,
                allocatedCancelPenaltyGroupSetting,
                workerDetail,
                workerEdit,
                workerCreate,
                deliveryFeeGroupWorkerSetting,
                cashAutoDeductGroupWorkerSetting,
                allocatedCancelPenaltyGroupWorkerSetting,
            },
        },
        workerBaromoneyHistory,
        workerBaromoneyHistoryDetailDialog,
        workerProfit,
        workerProfitDetailDialog,
        workerMonthlyAttendance,
        baromoneyReport,
        userManagement: {
            namespaced: true,
            modules: {
                userList,
                userPage,
            },
        },
        userPermissionSettingDialog,
        shareManagement: {
            namespaced: true,
            modules: {
                shareList,
                shareConfig,
            },
        },
        deliveryChargeAreaControl,
        deliveryChargeDialog,
        allocationAlert,
        allocationController,
    },
};
const vuexStore = createStore(store);
setGlobalStore(vuexStore);
export default vuexStore;
